export enum OPAStatus {
  Pending,
  Authorised,
  NotAuthorised,
}